import { Injectable } from "@angular/core";
import { HttpReserveProvider } from "../providers/http-reserve";
import { ChildAction } from "../actions/child.action";

import _ from "underscore";
import Utils from "../_com/utils";

/**
import { HttpReserve } from '../providers/http-reserve';
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Injectable()
export class ReserveAction {
  constructor(
    private httpReserveProvider: HttpReserveProvider,
    private childAction: ChildAction
  ) {}

  /**
   * 予約時の時間初期設定情報を取得する
   */
  getInitialReserveTime() {
    var s = new Date();
    s.setHours(9);
    s.setMinutes(0);
    var e = new Date();
    e.setHours(11);
    e.setMinutes(0);
    return [s, e];
  }

  /**
   * 入力された日付・時間を、検索可能なデータ形式を追加する
   */
  mergeSearchableDatetime(datetime) {
    datetime.date = Utils.date.format(datetime.input.date, "yyyy-MM-dd");

    // TODO: 9/9 複数日予約登録がスタッフ側で対応しきれていないようだったので、もとに戻す
    // let inputDate = datetime.input.date;
    // let dateArr = [];
    // // 日付を取得する
    // for(var index in inputDate){
    //   dateArr.push(Utils.date.format(inputDate[index], "yyyy-MM-dd"))
    // }
    // datetime.date = dateArr;
    datetime.time = [
      Utils.date.format(datetime.input.time[0], "HH:mm"),
      Utils.date.format(datetime.input.time[1], "HH:mm"),
    ];
  }

  mergeElapsedTime(datetime) {
    var s = Utils.time.minuteDistance(
      datetime.input.time[0],
      datetime.input.time[1]
    );
    datetime.elapsed = s;
  }

  /**
   * 登録処理（新規・更新含む）
   */
  saveOne(data) {
    //月齢情報をマージする
    this.mergeChildOfAgeIntoReserveData(
      data.children,
      data.datetime.input.date
    );

    //予約時間を算出する
    this.mergeElapsedTime(data.datetime);

    //検索用の日付・時間データを付与する
    this.mergeSearchableDatetime(data.datetime);

    return this.httpReserveProvider.saveOne(data);
  }

  /**
   * 登録処理（新規・更新含む）
   */
  saveInterviewSheet(data) {
    return this.httpReserveProvider.saveInterviewSheet(data);
  }

  update(data) {
    // 不要な情報を削除する
    if (data.family.data) {
      delete data.family.data;
    }

    data.children.map((child) => {
      delete child.data;
    });

    if (data.staff) {
      delete data.staff;
    }

    return this.httpReserveProvider.update(data);
  }

  /**
   * お迎え情報保存
   */
  savePickupInfo(data) {
    // 予約日時を"HH:mm"に変換
    if (typeof data.pickupInfo.pickup_time != "string") {
      data.pickupInfo.pickup_time = Utils.date.format(
        data.pickupInfo.pickup_time,
        "HH:mm"
      );
    }
    return this.httpReserveProvider.savePickupInfo(data);
  }

  /**
   * 写真リクエストへの返信
   */
  replyPhotoRequest(data) {
    return this.httpReserveProvider.replyPhotoRequest(data);
  }

  /**
   * 一覧取得
   */
  getList(conditons) {
    if (conditons["date"]) {
      conditons["date"] = Utils.date.format(conditons["date"], "yyyy-MM-dd");
    }
    return this.httpReserveProvider.getList(conditons);
  }

  /**
   * 問診票一覧取得
   */
  getInterviewData(condition) {
    // なんか条件追加する必要あればここで追加する
    return this.httpReserveProvider.getInterviewData(condition);
  }

  /**
   * お迎え情報取得
   */
  getPickupData(condition) {
    // なんか条件追加する必要あればここで追加する
    return this.httpReserveProvider.getPickupData(condition);
  }

  /**
   * 写真リクエスト返信可能状態にする
   */
  toEnablePhotoRequestReply(id) {
    return this.httpReserveProvider.toEnablePhotoRequestReply({ id: id });
  }

  /**
   * 写真リクエスト一覧取得
   */
  getListPhotoRequest() {
    return this.httpReserveProvider.getList({ photoRequest: true });
  }

  /**
   * ステータス変更
   */
  private changeStatus(reserveId, status) {
    var data = { id: reserveId, status: status };
    return this.httpReserveProvider.changeStatus(data);
  }

  /**
   * 写真リクエスト・メッセージを更新する
   */
  updatePhotoRequestMessage(reserveId, message) {
    var data = { id: reserveId, message: message };
    return this.httpReserveProvider.updatePhotoRequestMessage(data);
  }

  /**
   * 予約をキャンセルする
   */
  reserveCancel(reserveId) {
    return this.changeStatus(reserveId, 1);
  }

  /**
   * 予約情報へ子供の月齢情報をマージする
   */
  mergeChildOfAgeIntoReserveData(
    children: any[],
    resereveDate: Date = new Date()
  ) {
    return _.chain(children)
      .map((data, index) => {
        if (!_.isNull(data) && !_.isUndefined(data["Child"]["birthday"])) {
          var childOfAge = this.childAction.calcChildOfAge(
            new Date(data["Child"]["birthday"]),
            resereveDate
          );
          // TODO: 9/9 複数日予約登録がスタッフ側で対応しきれていないようだったので、もとに戻す
          // var childOfAge = this.childAction.calcChildOfAge(new Date(data["Child"]["birthday"]), resereveDate[index]);
          data["Child"]["childOfAge"] = childOfAge;
        }
        return data;
      })
      .value();
  }

  /**
   * 予約IDの配列を作成する
   */
  getReserveIds(reserves) {
    return _.chain(reserves)
      .filter((data) => {
        return true;
      })
      .map((data) => {
        return data["Reserve"]["id"];
      })
      .value();
  }
}



// WEBPACK FOOTER //
// ./src/actions/reserve.action.ts